import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
    selector: "app-update-login-warning",
    templateUrl: "./update-login-warning.component.html",
    styleUrls: ["./update-login-warning.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateLoginWarningComponent {
    @Input() shouldShowResetLink = false;
}
